module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"media_summary_title":"フォト&ビデオ","show_all":"全体を見る"}}')
  delete Component.options._Ctor
}
